<template>
  <div>
    <q-uploader
      url="/"
      style="width: 100%"
      flat
      bordered
      :multiple="multiple"
      :label="label"
      :color="color"
      :text-color="textColor"
      :accept="fileTypes"
      no-content-type
      :auto-upload="autoUpload"
      :max-file-size="maxFileSize"
      :max-total-size="maxTotalSize"
      :max-files="maxFiles"
      @added="fileSelected"
      @removed="fileRemove"
      @rejected="onRejected"
      ref="uploader"
    >
      <template v-slot:header="scope">
        <q-item dark>
          <q-item-section>
            <q-item-label>{{ scope.label }}</q-item-label>
          </q-item-section>

          <q-item-section side>
            <q-item-label caption>
              <span dir="ltr">{{ scope.uploadSizeLabel }}</span>
              {{of}}
              <span dir="ltr">{{ scope.maxTotalSize / 1024 / 1024 }}MB</span>
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>

      <template v-slot:list="scope">
        <q-list separator>

          <q-item v-for="file in scope.files" :key="file.__key">
            <q-item-section avatar v-if="file.__img">
              <q-avatar rounded>
                <img :src="file.__img.src">
              </q-avatar>
            </q-item-section>
            <q-item-section avatar v-else>
              <q-icon color="primary" name="far fa-file" />
            </q-item-section>

            <q-item-section>
              <q-item-label class="full-width ellipsis">
                {{ file.name }}
              </q-item-label>

              <q-item-label caption>
                {{ file.__sizeLabel }}
              </q-item-label>
            </q-item-section>

            <q-item-section side top>
              <q-btn
                size="xs"
                flat
                dense
                round
                icon="fa fa-trash"
                @click="scope.removeFile(file)"
                style="top: 8px; right: 8px"
              />
            </q-item-section>
          </q-item>

        </q-list>

        <hr v-if="fileCount" style="border: none; border-top: 1px solid #E0E0E0">

        <div>
          <q-btn
            outline
            type="a"
            icon="fa fa-paperclip"
            :label="attachFileLabel"
            v-if="scope.canAddFiles"
            :color="color"
            class="q-ma-xs"
          >
            <q-uploader-add-trigger/>
          </q-btn>
          <q-btn
            outline
            :icon="cameraIcon"
            @click="showCamera = true"
            v-if="camera"
            :label="cameraLabel"
            :color="color"
            class="q-ma-xs"
          />
        </div>
      </template>
    </q-uploader>
    <open-camera
      v-model="showCamera"
      style="width: 500px; max-width: 60vw;"
      position="top"
      :key="Math.random()"
      @captured="imageCaptured"
    />
    <p v-if="error.length" class="text-negative q-mt-sm q-field__bottom">
      {{ error }}
    </p>
  </div>
</template>

<script>

import OpenCamera from 'components/OpenCamera.vue'

export default {
  name: 'FileCollector',
  components: { OpenCamera },
  model: {
    prop: 'files',
    event: 'change'
  },
  props: {
    files: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    textColor: {
      type: String,
      default: 'white'
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    maxFileSize: {
      type: Number,
      default: 5120 * 1024
    },
    maxTotalSize: {
      type: Number,
      default: 20480 * 1024
    },
    maxFiles: {
      type: Number,
      default: 10
    },
    fileTypes: {
      type: String,
      default: 'image/*'
    },
    error: {
      type: String,
      default: ''
    },
    attachFileLabel: {
      type: String,
      default: 'Attach your file'
    },
    camera: {
      type: Boolean,
      default: false
    },
    cameraIcon: {
      type: String,
      default: 'fa fa-camera'
    },
    cameraLabel: {
      type: String,
      default: 'Take photo'
    },
    of: {
      type: String,
      default: 'of'
    }
  },
  data () {
    return {
      fileCount: 0,
      showCamera: false
    }
  },
  computed: {
    collectedFiles: {
      get: function () {
        return this.files
      },
      set: function (value) {
        this.$emit('change', value)
      }
    }
  },
  methods: {
    reset () {
      this.fileCount = 0
      this.collectedFiles = {}
      this.$refs.uploader.reset()
    },
    fileSelected ($event) {
      $event.forEach(file => {
        this.collectedFiles[`${this.name}[${this.fileCount++}]`] = file
      })

      this.$emit('collected', this.collectedFiles)
    },
    fileRemove ($event) {
      this.collectedFiles = Object.fromEntries(Object.entries(this.collectedFiles).filter(([key, value]) => value.__key !== $event[0].__key))
      this.fileCount--
      this.$emit('collected', this.collectedFiles)
    },
    onRejected (rejectedEntries) {
      this.$q.notify({
        type: 'negative',
        message: `${rejectedEntries.length} file(s) did not pass validation constraints`
      })
    },
    imageCaptured (image) {
      this.$refs.uploader.addFiles([image])
    }
  },
  watch: {
    fileCount (val) {
      this.$emit('count', val)
    }
  }
}
</script>
